export default PerfilController;

import * as _ from 'lodash';
import * as angular from 'angular';

/** @ngInject */
function PerfilController(Usuario, $filter) {
  var vm = this;
  var mask = $filter('mask');

  this.usuario = angular.copy(Usuario.obterUsuario());
  this.senha = {};
  this.todosTelefones = false;
  this.toggleTelefones = toggleTelefones;
  this.atualizar = atualizar;
  this.alterarSenha = alterarSenha;
  this.tiposVeiculos = Usuario.tiposVeiculos;
  this.tiposCarroceria = Usuario.tiposCarroceria;

  formatarDadosUsuario();

  function toggleTelefones() {
    vm.todosTelefones = !vm.todosTelefones;

    if (!vm.todosTelefones) {
      ['nr_telefone_fixo', 'nr_telefone_comercial'].map(limparTelefoneInvalido);
    }
  }

  function limparTelefoneInvalido(campo) {
    if ((vm.usuario[campo] || '').length < 10) {
      vm.usuario[campo] = '';
    }
  }

  function atualizar() {
    let usuario = _.assign(angular.copy(vm.usuario), {
      id_tipo_veiculo: vm.usuario.id_tipo_veiculo && vm.usuario.id_tipo_veiculo.id,
      id_tipo_carroceria: vm.usuario.id_tipo_carroceria && vm.usuario.id_tipo_carroceria.id
    });

    Usuario
      .atualizar(usuario)
      .then(() => Usuario.dialog('Cadastro atualizado com sucesso!'));
  }

  function alterarSenha() {
    Usuario
      .alterarSenha(vm.senha)
      .then(() => Usuario.dialog('Senha alterada com sucesso!'));
  }

  function formatarDadosUsuario() {
    var maskPhone: any = _.partialRight(mask, '(99) 9?9999-9999');
    vm.usuario.nr_telefone_celular = maskPhone(vm.usuario.nr_telefone_celular);
    vm.usuario.nr_telefone_fixo = maskPhone(vm.usuario.nr_telefone_fixo);
    vm.usuario.nr_telefone_comercial = maskPhone(vm.usuario.nr_telefone_comercial);

    vm.usuario.nr_cpf = mask(vm.usuario.nr_cpf, '999.999.999/99');
    vm.usuario.nr_cnpj = mask(vm.usuario.nr_cnpj, '99.999.999/9999-99');

    vm.usuario.id_tipo_veiculo = Usuario.find(vm.tiposVeiculos, vm.usuario.id_tipo_veiculo);
    vm.usuario.id_tipo_carroceria = Usuario.find(vm.tiposCarroceria, vm.usuario.id_tipo_carroceria);
  }
}



/** WEBPACK FOOTER **
 ** ./pages/consulta/usuario/perfil.controller.ts
 **/